
import Session from "./session"

// 30 mins
const USEREXCLUSIVELISTEXP = 30 * 60 * 1000;

class Profile {
	constructor(request) {
		this.request = request
		this.endpoint = 'profile'
	}

	async GetProfile(username, mode = "", payload = {}) {
		/*
		 * Possible values for mode: 'basic' | 'info' | 'organization' | 'organizationlist'| 'coupon
		 */

		let jwtToken = await Session.GetJWTToken();

		const body = {
			username: username,
			mode: mode,
			...payload
		}

		// Store user's exclusive list to localstorage to avoid multiple API calls
		if (mode === "exclusivelist") {
			/*
			 * If exclusive list is already stored in the localstorage, check expiration.
			 * If not expired, return the cached list.
			 * Otherwise, make an API call to fetch exclusive list, then store to localstorage
			 */
			const promise = new Promise((resolve, reject) => {
				let userExclusiveList = localStorage.getItem("userExclusiveList")

				let useCache = false;

				if (userExclusiveList !== null) {
					try {
						userExclusiveList = JSON.parse(userExclusiveList);

						if (Date.now() < userExclusiveList.exp) {
							useCache = true;
						}
					} catch (error) { }
				}

				if (useCache === true) {
					resolve(userExclusiveList);
				} else {
					this.request.send(
						`${this.endpoint}/get`,
						'POST',
						body,
						jwtToken
					).then((data) => {
						if (data.status === "OK") {
							const exp = Date.now() + USEREXCLUSIVELISTEXP;
							localStorage.setItem("userExclusiveList", JSON.stringify({ ...data, exp }));
						}

						resolve(data)
					}).catch((err) => {
						reject(err);
					})
				}
			})

			return promise;
		} else if (mode === "basic") {
			// Note: This is a temporary fix. Just to map typo 'Restuarant' value to 'Restaurant' in existingnegosyo_type.
			const promise = new Promise((resolve, reject) => {
				this.request.send(
					`${this.endpoint}/get`,
					'POST',
					body,
					jwtToken
				).then((data) => {
					let temp = { ...data };
					if (temp.data.hasOwnProperty("existingnegosyo_type")) {
						if (temp.data.existingnegosyo_type.toLowerCase().includes("restuarant")) {
							temp.data.existingnegosyo_type = "Restaurant";
						}
					}

					resolve(temp);
				}).catch((err) => {
					reject(err);
				})
			})

			return promise;
		}
		return this.request.send(
			`${this.endpoint}/get`,
			'POST',
			body,
			jwtToken
		)
	}

	async EditProfile(username, mode = "", payload) {
		/*
		 * Possible values for mode: 'organization'
		 */
		let jwtToken = await Session.GetJWTToken();

		const body = {
			username: username,
			mode,
			...payload
		}

		return this.request.send(
			`${this.endpoint}/update`,
			'POST',
			body,
			jwtToken
		)
	}

	async AddProfile(username, mode = "", payload = {}) {
		/*
		 * Possible values for mode: 'organization'
		 */

		let jwtToken = await Session.GetJWTToken();

		const body = {
			username,
			mode,
			...payload
		}

		return this.request.send(
			`${this.endpoint}/add`,
			'POST',
			body,
			jwtToken
		)
	}

	async DeleteProfile(username, mode = "", payload = {}) {
		/*
		 * Possible values for mode: 'organization'
		 */

		let jwtToken = await Session.GetJWTToken();

		const body = {
			username,
			mode,
			...payload
		}

		return this.request.send(
			`${this.endpoint}/delete`,
			'POST',
			body,
			jwtToken
		)
	}

	async GetProfileFieldList() {
		return this.request.requestData(`https://cdn.ngnw.ph/lists/profilekey/all.json`);
	}
}


export default Profile